import React from "react";

import { getTranslation } from "../../../../helpers/getLanguage";
import CustomCheckbox from "../../../inputs/CustomCheckbox";

//  sort, handleSortChange,

const HeaderTableComponents = ({ handlePickedAllComponents, selectedAll }) => {
  const SortableCell = ({ name, label }) => {
    // const isActive = name === sort.field;
    return (
      <div className="flex align-center width-100">
        <span
        // className={"components-row-text pointer" + (isActive ? " active" : "")}
        // onClick={() => handleSortChange(name)}
        >
          {label}
        </span>
        {/* {isActive && <div className={"sort-triangle-icon" + (sort.asc ? " asc" : "")} />} */}
      </div>
    );
  };

  return (
    <div className="components-container-header">
      <div className="components-row-header flex align-center">
        <div className="components-row-checkbox flex-center">
          <CustomCheckbox
            checked={selectedAll}
            handleChange={() => handlePickedAllComponents()}
            customClass="components-checkbox"
          />
        </div>

        <div className="components-row-name flex align-center">
          <SortableCell name="name" label={getTranslation("SORTABLE_CELL_NAME")} />
        </div>

        <div className="components-row-type flex align-center">
          <SortableCell name="type" label={getTranslation("SORTABLE_CELL_TYPE")} />
        </div>

        <div className="components-row-description flex align-center">
          <SortableCell name="description" label={getTranslation("SORTABLE_CELL_DESCRIPTION")} />
        </div>

        <div className="components-row-attributes flex align-center">
          <SortableCell name="attributesCount" label={getTranslation("SORTABLE_CELL_ATTRIBUTES_COUNT")} />
        </div>

        <div className="components-row-importance flex align-center">
          <SortableCell name="importance" label={getTranslation("SORTABLE_CELL_IMPORTANCE")} />
        </div>

        <div className="components-row-product flex align-center">
          <SortableCell name="productName" label={getTranslation("SORTABLE_CELL_PROJECT_NAME")} />
        </div>
      </div>
    </div>
  );
};

export default HeaderTableComponents;
